<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="configFamilySettings"
  [canEdit]="[accessRights.Settings_write, accessRights.ConfigurationOptions_write]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="family-settings"
        >
          <span class="fs-3">{{ 'configurationOptionModule.family' | translate }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="family-settings">
      <div class="row">
        <div class="col-lg-6">
          <div class="mb-4">
            <fieldset>
              <legend class="form-label">{{ 'general.active' | translate }}</legend>
              <div class="d-flex align-items-center">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="familyIsActive"
                    value="{{ true }}"
                    id="familyIsActiveYes"
                    (click)="patchValueForm('isActive', true)"
                    autocomplete="off"
                    [checked]="!!form.value.isActive"
                  />
                  <label class="btn" for="familyIsActiveYes">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="familyIsActive"
                    id="familyIsActiveNo"
                    value="{{ false }}"
                    (click)="patchValueForm('isActive', false)"
                    autocomplete="off"
                    [checked]="!form.value.isActive"
                  />
                  <label class="btn" for="familyIsActiveNo">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'configurationOptionModule.requireChildApproval' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="familyRequireChildApproval"
                    value="{{ true }}"
                    id="familyRequireChildApprovalYes"
                    (click)="patchValueForm('requireChildApproval', true)"
                    autocomplete="off"
                    [checked]="!!form.value.requireChildApproval"
                  />
                  <label class="btn" for="familyRequireChildApprovalYes">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="familyRequireChildApproval"
                    id="familyRequireChildApprovalNo"
                    value="{{ false }}"
                    (click)="patchValueForm('requireChildApproval', false)"
                    autocomplete="off"
                    [checked]="!form.value.requireChildApproval"
                  />
                  <label class="btn" for="familyRequireChildApprovalNo">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="mb-4">
            <fieldset>
              <legend class="form-label">
                {{ 'configurationOptionModule.allowChildren' | translate }}
              </legend>
              <div class="d-flex align-items-center">
                <div class="btn-group-segment">
                  <input
                    type="radio"
                    class="btn-check"
                    name="familyAllowChildren"
                    value="{{ true }}"
                    id="familyAllowChildrenYes"
                    (click)="patchValueForm('allowChildren', true)"
                    autocomplete="off"
                    [checked]="!!form.value.allowChildren"
                  />
                  <label class="btn" for="familyAllowChildrenYes">
                    {{ 'general.yes' | translate }}
                  </label>

                  <input
                    type="radio"
                    class="btn-check"
                    name="familyAllowChildren"
                    id="familyAllowChildrenNo"
                    value="{{ false }}"
                    (click)="patchValueForm('allowChildren', false)"
                    autocomplete="off"
                    [checked]="!form.value.allowChildren"
                  />
                  <label class="btn" for="familyAllowChildrenNo">
                    {{ 'general.no' | translate }}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-4">
            <label
              id="childDefaultCategoryLabel"
              class="form-label"
              for="childDefaultCategory"
            >
              {{ 'configurationOptionModule.childDefaultCategory' | translate }}
            </label>
            <div class="input-group">
              <input
                id="childDefaultCategory"
                type="number"
                class="form-control"
                [attr.aria-invalid]="
                  form.controls.childDefaultCategory.dirty &&
                  form.controls.childDefaultCategory.invalid
                    ? 'true'
                    : null
                "
                min="0"
                max="9"
                aria-labelledby="childDefaultCategoryLabel"
                aria-describedby="childDefaultCategoryError"
                formControlName="childDefaultCategory"
                required
              />
            </div>
            <p
              id="childDefaultCategoryError"
              class="invalid-feedback"
              role="alert"
              aria-atomic="true"
              *ngIf="
                form.controls.childDefaultCategory.dirty &&
                form.controls.childDefaultCategory.invalid
              "
            >
              <i
                role="img"
                class="fas fa-exclamation-circle"
                aria-hidden="true"
              ></i>
              {{ 'general.value' | translate }}
              {{ 'general.isInvalid' | translate }}
            </p>
          </div>

          <div class="mb-4">
            <label
              id="maxMembersPerFamilyLabel"
              class="form-label"
              for="maxMembersPerFamily"
            >
              {{ 'configurationOptionModule.maxMembersPerFamily' | translate }}
            </label>
            <input
              id="maxMembersPerFamily"
              type="number"
              class="form-control"
              min="0"
              aria-labelledby="maxMembersPerFamilyLabel"
              formControlName="maxMembersPerFamily"
            />
          </div>
        </div>
      </div>

      <div class="mb-4" formGroupName="childRegistrationForm">
        <div class="form-label">{{
          'configurationOptionModule.childRegistrationForm' | translate
        }}</div>
        <div class="row">
          <div
            class="col-lg-6 mb-3"
            *ngFor="let field of childRegistrationFields"
            [formGroupName]="field.key"
          >
            <fieldset>
              <legend class="form-label">{{ field.label | translate }}</legend>
              <div class="d-flex align-items-center flex-wrap">
                <div class="me-4 mb-2">
                  <span class="form-label d-block">{{
                    'configurationOptionModule.visible' | translate
                  }}</span>
                  <div class="btn-group-segment">
                    <input
                      type="radio"
                      class="btn-check"
                      [name]="'familyChildVisible' + field.key"
                      value="{{ true }}"
                      [id]="'familyChildVisibleYes' + field.key"
                      (click)="patchChildVisibility(field.key, true)"
                      autocomplete="off"
                      [checked]="
                        !!form.value.childRegistrationForm?.[field.key]
                          ?.visible
                      "
                    />
                    <label
                      class="btn"
                      [for]="'familyChildVisibleYes' + field.key"
                    >
                      {{ 'general.yes' | translate }}
                    </label>

                    <input
                      type="radio"
                      class="btn-check"
                      [name]="'familyChildVisible' + field.key"
                      value="{{ false }}"
                      [id]="'familyChildVisibleNo' + field.key"
                      (click)="patchChildVisibility(field.key, false)"
                      autocomplete="off"
                      [checked]="
                        !form.value.childRegistrationForm?.[field.key]
                          ?.visible
                      "
                    />
                    <label
                      class="btn"
                      [for]="'familyChildVisibleNo' + field.key"
                    >
                      {{ 'general.no' | translate }}
                    </label>
                  </div>
                </div>

                <div
                  class="mb-2"
                  *ngIf="
                    !!form.value.childRegistrationForm?.[field.key]?.visible
                  "
                >
                  <span class="form-label d-block">{{
                    'configurationOptionModule.required' | translate
                  }}</span>
                  <div class="btn-group-segment">
                    <input
                      type="radio"
                      class="btn-check"
                      [name]="'familyChildRequired' + field.key"
                      value="{{ true }}"
                      [id]="'familyChildRequiredYes' + field.key"
                      (click)="patchChildRequired(field.key, true)"
                      autocomplete="off"
                      [checked]="
                        !!form.value.childRegistrationForm?.[field.key]
                          ?.required
                      "
                    />
                    <label
                      class="btn"
                      [for]="'familyChildRequiredYes' + field.key"
                    >
                      {{ 'general.yes' | translate }}
                    </label>

                    <input
                      type="radio"
                      class="btn-check"
                      [name]="'familyChildRequired' + field.key"
                      value="{{ false }}"
                      [id]="'familyChildRequiredNo' + field.key"
                      (click)="patchChildRequired(field.key, false)"
                      autocomplete="off"
                      [checked]="
                        !form.value.childRegistrationForm?.[field.key]
                          ?.required
                      "
                    />
                    <label
                      class="btn"
                      [for]="'familyChildRequiredNo' + field.key"
                    >
                      {{ 'general.no' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="form.invalid"
          [canSee]="[
            accessRights.Settings_write,
            accessRights.ConfigurationOptions_write
          ]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
